import Styles from './StationConnectorMapComponent.module.css'
import { IFText } from 'Components'
import icons from '../../Theme/Icons'
import InfinityEnums from '../../Enums/InfinityEnums'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
const { ConnectorPowerLevel } = InfinityEnums

const StationConnectorMapComponent = ({ connector, isChargePointOnline }) => {
  const handleType = (type) => {
    switch (type) {
      case InfinityEnums.ConnectorType.IEC_62196_T1:
        return {
          icon: icons.type1({ width: 24, height: 24, color: Colors.black }),
          name: 'Type 1',
        }
      case InfinityEnums.ConnectorType.CHADEMO:
        return {
          icon: icons.chademo({ width: 24, height: 24, color: Colors.black }),
          name: 'Chademo',
        }
      case InfinityEnums.ConnectorType.IEC_62196_T2:
        return {
          icon: icons.type2({ width: 24, height: 24, color: Colors.black }),
          name: 'Type 2',
        }
      case InfinityEnums.ConnectorType.IEC_62196_T2_COMBO:
        return {
          icon: icons.comboCCS({ width: 24, height: 24, color: Colors.black }),
          name: 'Combo CCS',
        }
      case InfinityEnums.ConnectorType.DOMESTIC_F:
        return {
          icon: icons.schuko({ width: 24, height: 24, color: Colors.black }),
          name: 'Schuko',
        }
      default:
        return null
    }
  }

  const connectorTypeFormatted = handleType(connector.type)

  const getIconColor = () => {
    if (!isChargePointOnline) {
      return Colors.OfflineConnector
    }
    let iconColor = Colors.AvailableConnector
    if (connector.status !== InfinityEnums.ConnectorStatus.AVAILABLE) {
      switch (connector.status) {
        case InfinityEnums.ConnectorStatus.UNAVAILABLE:
        case InfinityEnums.ConnectorStatus.FAULTED:
          iconColor = Colors.UnAvailableConnector
          break
        case InfinityEnums.ConnectorStatus.PREPARING:
        case InfinityEnums.ConnectorStatus.SUSPENDEDEV:
        case InfinityEnums.ConnectorStatus.SUSPENDEDEVSE:
        case InfinityEnums.ConnectorStatus.RESERVED:
          iconColor = Colors.SuspendedConnector
          break
        // Coarse in-use status post status-model inversion.
        case InfinityEnums.ConnectorStatus.OCCUPIED:
          iconColor = Colors.OccupiedConnector
          break
        case InfinityEnums.ConnectorStatus.CHARGING:
        case InfinityEnums.ConnectorStatus.FINISHING:
          iconColor = Colors.ChargingConnector
          break
      }
    }
    return iconColor
  }

  return (
    <div
      className={Styles.Connector}
      style={{
        border: `1px solid ${Colors.ConnectorComponentBorder}`,
        backgroundColor: Colors.white,
      }}
    >
      <div
        className={Styles.ChargerSpeedContainer}
        style={{ backgroundColor: Colors.ChargerSpeedContainerBackground }}
      >
        <div className={Styles.ConnectorSpeedIconContainer}>
          {connector.maxPower <= ConnectorPowerLevel.LEVEL1 ? (
            <div className={Styles.FlashIcon}>{icons.flash}</div>
          ) : connector.maxPower <= ConnectorPowerLevel.LEVEL2 ? (
            [...Array(2)].map((e, index) => {
              return (
                <div key={`flashComp-${index}`} className={Styles.FlashIcon}>
                  {icons.flash}
                </div>
              )
            })
          ) : (
            [...Array(3)].map((e, index) => {
              return (
                <div key={`flashComp-${index}`} className={Styles.FlashIcon}>
                  {icons.flash}
                </div>
              )
            })
          )}
        </div>

        <div className={Styles.DividedText}>
          <IFText className={Styles.killowattNumberText}>
            {connector.maxPower}
          </IFText>
          <IFText className={Styles.KiloWattText}> {'kW'}</IFText>
        </div>
      </div>
      <div className={Styles.ChargerTypeContainer}>
        {connectorTypeFormatted?.icon}
        <IFText className={Styles.ConnectorText}>
          {connectorTypeFormatted?.name}
        </IFText>
      </div>

      <IFText
        className={Styles.ConnectorStatusText}
        style={{ color: getIconColor() }}
      >
        {isChargePointOnline
          ? connector.status
          : InfinityEnums.ConnectorStatus.OFFLINE}
      </IFText>
    </div>
  )
}

StationConnectorMapComponent.propTypes = {
  connector: PropTypes.object,
}

export default StationConnectorMapComponent
